export function formatHeat(value: number): string {
  if (value >= 10000) {
    const wan = value / 10000;
    return `${wan.toFixed(1)}万`;
  }
  return `${value}`;
}

export function formatDateLabel(date: string): string {
  const parts = date.split("-");
  if (parts.length !== 3) return date;
  return `${parts[1]}-${parts[2]}`;
}

export function formatFullDate(date: string): string {
  const parts = date.split("-");
  if (parts.length !== 3) return date;
  return `${parts[0]} 年 ${Number(parts[1])} 月 ${Number(parts[2])} 日`;
}